<template>
  <div class="loading-screen"
       v-loading="true"
       element-loading-text="页面加载中……"
       element-loading-background="rgba(255,255,255, 0.5)">
  </div>
</template>

<script>

export default {
  name: "LoadingCircle",
  data() {
    return {
      loading: null
    }
  },
  created() {
    // this.loading = Loading.service({
    //   lock: true,
    //   text: '页面加载中……',
    //   background: 'rgba(255,255,255, 0.5)'
    // })
  },
  destroyed() {
    // this.loading?.close()
  }
}
</script>

<style scoped lang="scss">
.loading-screen {
  height: 100%;
}
</style>
